const HEIGHT_OPTIONS = {
  RS19: ['15HE', '18HE', '22HE', '27HE', '32HE', '37HE', '42HE'],
  RSPL19: ['12HE', '16HE', '20HE', '22HE', '26HE', '32HE', '36HE', '42HE']
};

// Premiumline-Zubehör, das in ALLE 19"-Schränke passt (unabhängig von Breite/Tiefe)
const UNIVERSAL_ACCESSORIES = [
  'RSPL19-FTDT2',
  'RSPL19-FT2',
  'RSPL19-FTDT4',
  'RSPL19-FT4',
  'RSPL19-FTDT6',
  'RSPL19-FT6',
  'RSPL19-10PDU',
  'RSPL19-12PDU',
  'RSPL19-8PDU'
];

let csvCache = null;
let latestRequestId = 0;
let rackNumericPrice = 0;

// Übersetzungen kommen aus window.RC_I18N (gesetzt im Template page.Serverrack-Configurator.liquid
// aus locales/*.json). Die deutschen Fallbacks greifen, falls das Objekt fehlt.
function rcT(key, fallback) {
  return (window.RC_I18N && window.RC_I18N[key]) || fallback;
}
const RC_MISC_CATEGORY = rcT('miscCategory', 'Sonstiges');

const PILL_GROUP_IDS = ['line', 'width', 'depth', 'height', 'door'];

function load() {
  populateHeightOptions(document.getElementById('line').value);
  const height = document.getElementById('height');
  if ([...height.options].some(option => option.value === '18HE')) {
    height.value = '18HE';
  }
  PILL_GROUP_IDS.forEach(rebuildPillGroup);
  generateRackConfig();
}

// Baut eine Button-Gruppe ("Pills") über einem nativen <select>, damit die
// Auswahl visuell moderner ist, ohne die bestehende select-basierte Logik zu ändern.
function rebuildPillGroup(selectId) {
  const select = document.getElementById(selectId);
  if (!select) return;

  select.classList.add('rc-native-select');

  let wrapper = document.getElementById(`${selectId}-pills`);
  if (wrapper) wrapper.remove();

  wrapper = document.createElement('div');
  wrapper.className = 'pill-group';
  wrapper.id = `${selectId}-pills`;

  Array.from(select.options).forEach(option => {
    const btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'pill';
    btn.textContent = option.textContent.trim();
    btn.addEventListener('click', () => {
      if (select.value === option.value) return;
      select.value = option.value;
      select.dispatchEvent(new Event('change', { bubbles: true }));
    });
    wrapper.appendChild(btn);
  });

  select.insertAdjacentElement('afterend', wrapper);
  syncPillGroup(selectId);
}

function syncPillGroup(selectId) {
  const select = document.getElementById(selectId);
  const wrapper = document.getElementById(`${selectId}-pills`);
  if (!select || !wrapper) return;

  Array.from(wrapper.children).forEach((btn, i) => {
    const option = select.options[i];
    if (!option) return;
    btn.classList.toggle('active', option.value === select.value);
    btn.classList.toggle('is-hidden', option.style.display === 'none');
    btn.disabled = option.disabled;
  });
}

function syncAllPillGroups() {
  PILL_GROUP_IDS.forEach(syncPillGroup);
}

function populateHeightOptions(line) {
  const heightSelect = document.getElementById('height');
  const options = HEIGHT_OPTIONS[line] || HEIGHT_OPTIONS.RS19;
  const currentValue = heightSelect.value;
  heightSelect.innerHTML = options
    .map(h => `<option${h === '15HE' ? ' id="15HEheight"' : ''} value="${h}">${h}</option>`)
    .join('');
  heightSelect.value = options.includes(currentValue) ? currentValue : options[0];
  rebuildPillGroup('height');
}

function onLineChange() {
  populateHeightOptions(document.getElementById('line').value);
  generateRackConfig();
}

function buildArticleNumber(line, width, depth, height, door) {
  let articleNumber = line === 'RSPL19' ? 'RSPL19-' : 'RS19-';
  articleNumber += (width === '800mm') ? '8' : '6';

  if (depth === '600mm') {
    articleNumber += '6';
  } else if (depth === '800mm') {
    articleNumber += '8';
  } else if (depth === '1000mm') {
    articleNumber += '0';
  } else if (depth === '1200mm') {
    articleNumber += '2';
  }

  articleNumber += height.replace('HE', '');

  if (door === 'Perforierte Tür') {
    if (line === 'RS19' && width === '800mm' && height === '42HE') {
      articleNumber += 'PD';
    } else {
      articleNumber += 'PP';
    }
  }

  return articleNumber;
}

function getCurrentSelection() {
  return {
    line: document.getElementById('line').value,
    height: document.getElementById('height').value,
    depth: document.getElementById('depth').value,
    width: document.getElementById('width').value,
    door: document.getElementById('door').value
  };
}

async function loadCSV() {
  if (csvCache) return csvCache;

  const response = await fetch('https://cdn.shopify.com/s/files/1/0689/1002/2924/files/Rockstable_Zubehoer_Fitting.csv?v=1740059791');
  const text = await response.text();
  csvCache = text.split('\n').map(row => row.split(';'));
  return csvCache;
}

document.addEventListener("DOMContentLoaded", () => {
  const accessoryOutput = document.getElementById('accessoryOutput');
  if (accessoryOutput) {
    accessoryOutput.addEventListener('change', updateFinalPrice);
  } else {
    console.error("Fehler: Element 'accessoryOutput' nicht gefunden.");
  }
});

function hideValue() {
  const depth = document.getElementById('depth');
  const width = document.getElementById('width');
  const height = document.getElementById('height');

  const depthvalue = document.getElementById('600mmdepth');
  const widthvalue = document.getElementById('800mmwidth');
  const heightvalue = document.getElementById('15HEheight');

  if (width.value === "800mm") {
    depthvalue.style.display = 'none';
    if (depth.value === "600mm") {
      depth.value = "800mm";
    }
  } else {
    depthvalue.style.display = 'block';
  }

  if (depth.value === "600mm") {
    widthvalue.style.display = 'none';
  } else {
    widthvalue.style.display = 'block';
  }

  if (heightvalue) {
    if (width.value === "600mm") {
      if (depth.value === "1000mm") {
        heightvalue.style.display = 'block';
      } else {
        heightvalue.style.display = 'none';
      }
    } else {
      heightvalue.style.display = 'none';
    }
  }

  syncAllPillGroups();
}

async function generateRackConfig() {
  const requestId = ++latestRequestId;
  hideValue();

  const { line, height, depth, width, door } = getCurrentSelection();
  const articleNumber = buildArticleNumber(line, width, depth, height, door);

  const result = await getProductInfo(articleNumber);
  if (requestId !== latestRequestId) return; // eine neuere Auswahl läuft bereits

  if (result) {
    const { image, available, price } = result;
    rackNumericPrice = price;

    // Für die Anzeige das übersetzte Label der Tür-Option verwenden, nicht den (deutschen) value
    const doorSelect = document.getElementById('door');
    const doorLabel = doorSelect.selectedOptions[0] ? doorSelect.selectedOptions[0].textContent.trim() : door;

    const output = `${rcT('configHeading', 'Serverschrank Konfiguration:')}

          ${rcT('height', 'Höhe')}: ${height}
          ${rcT('depth', 'Tiefe')}:${depth}
          ${rcT('width', 'Breite')}:${width}
          ${rcT('door', 'Tür')}: ${doorLabel}
          ${rcT('articleNumber', 'Artikelnummer')}: ${articleNumber}`;

    const rack_availableForSale = available ? rcT('available', 'Verfügbar') : rcT('onRequest', 'Auf Anfrage');

    document.getElementById('output').innerText = output;
    document.getElementById('rackImage').src = image;
    document.getElementById('rackImage').style.display = 'block';

    const priceOutputEl = document.getElementById('priceOutput');
    if (price) {
      animateValue(priceOutputEl, price, { prefix: rcT('pricePrefix', 'Preis: ') });
    } else {
      delete priceOutputEl.dataset.animationToken;
      priceAnimationState.delete(priceOutputEl);
      priceOutputEl.textContent = rcT('priceNotAvailable', 'Preis: Nicht verfügbar');
    }

    const element_availability = document.getElementById("rack_availability");
    element_availability.textContent = rack_availableForSale;
    element_availability.dataset.available = available ? 'true' : 'false';
    element_availability.style.color = available ? "#1a8f3c" : "#d92d2d";
  } else {
    rackNumericPrice = 0;
    document.getElementById('rackImage').style.display = 'none';
    document.getElementById('output').innerText = rcT('itemNotFound', 'Artikel nicht gefunden.');
    const priceOutputEl = document.getElementById('priceOutput');
    delete priceOutputEl.dataset.animationToken;
    priceAnimationState.delete(priceOutputEl);
    priceOutputEl.textContent = rcT('itemNotFound', 'Artikel nicht gefunden.');
  }

  replayAnimation(document.getElementById('rackResultCard'), 'rc-updated');

  await displayAccessories(width.replace('mm', ''), depth.replace('mm', ''), requestId);
  if (requestId !== latestRequestId) return;

  checkAvailabilityAndModifyButton();
  await updateFinalPrice();
}

function replayAnimation(element, className) {
  if (!element) return;
  element.classList.remove(className);
  // Reflow erzwingen, damit die CSS-Animation bei erneutem Hinzufügen der Klasse neu startet
  void element.offsetWidth;
  element.classList.add(className);
}

async function findAccessories(width, depth) {
  const csvData = await loadCSV();
  const sized = [];
  const relevantRows = csvData.slice(1, 8);

  relevantRows.forEach(row => {
    const size = row[0];
    const articleNumbers = row.slice(1);

    if (!size || articleNumbers.every(num => num.trim() === '')) return;

    if (size === `${width}x${depth}`.replace('mm', '').trim()) {
      sized.push(...articleNumbers.filter(num => num.trim() !== ''));
    }
  });

  const universal = UNIVERSAL_ACCESSORIES.filter(sku => !sized.includes(sku));

  return { sized, universal };
}

async function getProductInfo(articleNumber) {
  const cleanArticleNumber = articleNumber.trim();
  const query = `
    {
      products(first: 1, query: "${cleanArticleNumber}") {
        edges {
          node {
            title
            availableForSale
            variants(first: 1) {
              edges {
                node {
                  price {
                    amount
                    currencyCode
                  }
                  sku
                  id
                }
              }
            }
            featuredImage {
              originalSrc
            }
            zubehoertyp: metafield(namespace: "custom", key: "zubeh_rtyp") {
              value
            }
          }
        }
      }
    }
  `;

  const response = await fetch('https://5d2cd9-2.myshopify.com/api/2021-07/graphql.json', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-Shopify-Storefront-Access-Token': '25639fe90c19e3bb079ab02c58ff81ef',
    },
    body: JSON.stringify({ query })
  });

  const result = await response.json();

  if (!result.data || !result.data.products || result.data.products.edges.length === 0) {
    console.error(`Kein Produkt mit der Artikelnummer ${articleNumber} gefunden.`);
    return null;
  }

  const productData = result.data.products.edges[0]?.node;
  const variantData = productData.variants.edges[0]?.node;

  if (!variantData || !variantData.price || !variantData.price.amount) {
    console.error(`Keine Preisdaten für Artikelnummer ${articleNumber} gefunden.`);
    return null;
  }

  return {
    productID: productData.id,
    title: productData.title ?? 'Kein Titel',
    price: parseFloat(variantData.price.amount),
    available: productData.availableForSale,
    image: productData.featuredImage?.originalSrc ?? 'fallback-image.jpg',
    sku: variantData.sku ?? 'Unbekannt',
    variantID: variantData.id,
    category: productData.zubehoertyp?.value?.trim() || RC_MISC_CATEGORY
  };
}

// Alle SKUs in einem einzigen GraphQL-Request abfragen
async function getMultipleProductInfos(skus) {
  if (skus.length === 0) return [];

  const query = `{
    ${skus.map((sku, i) => `
      product${i}: products(first: 1, query: "${sku.trim()}") {
        edges {
          node {
            title
            availableForSale
            variants(first: 1) {
              edges {
                node {
                  price { amount currencyCode }
                  sku
                  id
                }
              }
            }
            featuredImage { originalSrc }
            zubehoertyp: metafield(namespace: "custom", key: "zubeh_rtyp") {
              value
            }
          }
        }
      }
    `).join('')}
  }`;

  const response = await fetch('https://5d2cd9-2.myshopify.com/api/2021-07/graphql.json', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-Shopify-Storefront-Access-Token': '25639fe90c19e3bb079ab02c58ff81ef',
    },
    body: JSON.stringify({ query })
  });

  const result = await response.json();

  return skus.map((sku, i) => {
    const edges = result.data?.[`product${i}`]?.edges;
    if (!edges || edges.length === 0) return null;

    const node = edges[0].node;
    const variant = node.variants.edges[0]?.node;
    if (!variant) return null;

    return {
      title: node.title,
      available: node.availableForSale,
      price: parseFloat(variant.price.amount),
      image: node.featuredImage?.originalSrc ?? 'fallback-image.jpg',
      sku: variant.sku,
      variantID: variant.id,
      category: node.zubehoertyp?.value?.trim() || RC_MISC_CATEGORY
    };
  });
}

function escapeHtml(value) {
  const div = document.createElement('div');
  div.textContent = value;
  return div.innerHTML;
}

function renderAccessoryCard(sku, accessoryInfo, staggerIndex) {
  const accessoryDiv = document.createElement('div');
  accessoryDiv.classList.add('accessory-item');
  accessoryDiv.style.animationDelay = `${Math.min(staggerIndex, 10) * 45}ms`;
  accessoryDiv.innerHTML = `
    <img src="${accessoryInfo.image}" alt="${accessoryInfo.title}" class="accessory-image">
    <div class="accessory-title">${accessoryInfo.title}</div>
    <span class="accessory-price" data-sku="${sku}">${formatPrice(accessoryInfo.price)}${rcT('perPiece', '/Stk.')}</span>
    <div class="accessory-availability" data-available="${accessoryInfo.available}" id="${accessoryInfo.available ? 'Verfügbar' : 'Nicht_verfügbar'}">
      ${accessoryInfo.available ? rcT('available', 'Verfügbar') : rcT('requestQuote', 'Anfrage stellen')}
    </div>
    <select class="accessory-select" id="${sku}">
      <option value="0">0</option>
      ${[...Array(11).keys()].slice(1).map(i => `<option value="${i}">${i}</option>`).join('')}
    </select>
    <span class="accessory-total" id="total-${accessoryInfo.sku}" style="display:none;">${rcT('subtotalPrefix', 'Gesamt: ')}${formatPrice(0)}</span>
  `;
  return accessoryDiv;
}

async function displayAccessories(width, depth, requestId = ++latestRequestId) {
  const loadingSpinner = document.getElementById('loadingSpinner');
  loadingSpinner.style.display = 'block';

  const { sized, universal } = await findAccessories(width, depth);
  const accessories = [...sized, ...universal];
  if (requestId !== latestRequestId) {
    loadingSpinner.style.display = 'none';
    return window.accessoryPrices || {};
  }

  const accessoryOutput = document.getElementById('accessoryOutput');
  accessoryOutput.innerHTML = '';

  // Skeleton-Loader für alle auf einmal anzeigen
  accessories.forEach(() => {
    const skeletonDiv = document.createElement('div');
    skeletonDiv.classList.add('skeleton-container');
    skeletonDiv.innerHTML = `
      <div class="skeleton skeleton-image"></div>
      <div class="skeleton skeleton-text"></div>
      <div class="skeleton skeleton-price"></div>
      <div class="skeleton skeleton-text"></div>
      <div class="skeleton skeleton-select"></div>
    `;
    accessoryOutput.appendChild(skeletonDiv);
  });

  // Alle SKUs in einem Request abfragen
  const cleanedSkus = accessories.map(sku => sku.replace(/["]/g, '').trim());
  const results = await getMultipleProductInfos(cleanedSkus);

  if (requestId !== latestRequestId) {
    loadingSpinner.style.display = 'none';
    return window.accessoryPrices || {};
  }

  const accessoryPrices = {};
  accessoryOutput.innerHTML = ''; // Skeletons entfernen

  if (accessories.length === 0) {
    const emptyMessage = document.createElement('p');
    emptyMessage.className = 'accessory-empty';
    emptyMessage.textContent = rcT('noAccessories', 'Für diese Konfiguration ist aktuell kein Zubehör hinterlegt.');
    accessoryOutput.appendChild(emptyMessage);
  }

  // Zubehör nach dem Produkt-Metafeld custom.zubeh_rtyp gruppieren
  const groups = new Map();
  results.forEach((accessoryInfo, index) => {
    const sku = cleanedSkus[index];
    if (!accessoryInfo) return;

    accessoryPrices[sku] = accessoryInfo.price;

    const category = accessoryInfo.category || RC_MISC_CATEGORY;
    if (!groups.has(category)) groups.set(category, []);
    groups.get(category).push({ sku, accessoryInfo });
  });

  const sortedCategories = Array.from(groups.keys()).sort((a, b) => {
    if (a === RC_MISC_CATEGORY) return 1;
    if (b === RC_MISC_CATEGORY) return -1;
    return a.localeCompare(b, window.RC_LOCALE || 'de');
  });

  let cardIndex = 0;
  sortedCategories.forEach((category, categoryIndex) => {
    const items = groups.get(category);

    const details = document.createElement('details');
    details.className = 'accessory-accordion';
    if (categoryIndex === 0) details.open = true;

    const summary = document.createElement('summary');
    summary.className = 'accessory-accordion__summary';
    summary.innerHTML = `
      <span class="accessory-accordion__title">${escapeHtml(category)}</span>
      <span class="accessory-accordion__count">${items.length}</span>
      <svg class="accessory-accordion__chevron" viewBox="0 0 20 20" fill="none" aria-hidden="true">
        <path d="M5 7.5L10 12.5L15 7.5" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    `;
    details.appendChild(summary);

    const groupList = document.createElement('div');
    groupList.className = 'accessory-group-list';
    details.appendChild(groupList);

    items.forEach(({ sku, accessoryInfo }) => {
      groupList.appendChild(renderAccessoryCard(sku, accessoryInfo, cardIndex));
      cardIndex += 1;
    });

    accessoryOutput.appendChild(details);
  });

  loadingSpinner.style.display = 'none';

  document.querySelectorAll('.accessory-image').forEach(image => {
    image.addEventListener('click', function () {
      openImageModal(this.src);
    });
  });

  document.querySelectorAll('.accessory-select').forEach(select => {
    select.addEventListener('change', checkAvailabilityAndModifyButton);
  });

  window.accessoryPrices = accessoryPrices;
  return accessoryPrices;
}

function openImageModal(imageSrc) {
  const modal = document.getElementById('imageModal');
  const modalImg = document.getElementById('modalImage');
  modal.style.display = 'flex';
  modalImg.src = imageSrc;

  const closeButton = document.querySelector('.close');
  closeButton.onclick = function () {
    modal.style.display = 'none';
  };

  modal.onclick = function (event) {
    if (event.target === modal) {
      modal.style.display = 'none';
    }
  };
}

function checkAvailabilityAndModifyButton() {
  const unavailableItems = [];
  const selects = document.querySelectorAll('.accessory-select');

  selects.forEach(select => {
    const sku = select.id.trim();
    // data-available statt Anzeigetext prüfen, damit die Logik sprachunabhängig ist
    const available = document.getElementById(sku).parentNode.querySelector('.accessory-availability').dataset.available === 'true';
    const quantity = parseInt(select.value);

    if (!available && quantity > 0) {
      unavailableItems.push(sku);
    }
  });

  const finalButton = document.getElementById('finalAddToCartButton');
  const finalButtonLabel = finalButton.querySelector('.rc-button-label') || finalButton;
  const rackAvailable = document.getElementById('rack_availability').dataset.available === 'true';

  if (!rackAvailable || unavailableItems.length > 0) {
    finalButtonLabel.textContent = rcT('requestQuote', 'Anfrage stellen');
    finalButton.onclick = () => showInquiryForm(unavailableItems);
  } else {
    finalButtonLabel.textContent = rcT('addToCart', 'Zum Warenkorb hinzufügen');
    finalButton.onclick = addToCart;
  }
}

function formatPrice(price) {
  let value = parseFloat(price) || 0;
  // Globaler Brutto/Netto-Schalter im Header (Klasse wird in theme.liquid gesetzt).
  // Intern wird immer mit Brutto gerechnet, nur die Anzeige wird umgerechnet.
  if (document.documentElement.classList.contains('price-mode-netto')) {
    value = value / 1.19;
  }
  return value.toLocaleString(window.RC_LOCALE || 'de-DE', {
    style: 'currency',
    currency: 'EUR'
  });
}

// Bei Moduswechsel alle sichtbaren Preise des Konfigurators neu rendern
document.addEventListener('price-mode:change', () => {
  if (document.getElementById('priceOutput')) {
    generateRackConfig();
  }
});

const prefersReducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
const priceAnimationState = new WeakMap();
let animationTokenCounter = 0;

// Animiert eine Preisanzeige fließend vom bisherigen auf den neuen Wert, statt hart zu springen.
function animateValue(element, toValue, { prefix = '', duration = 450 } = {}) {
  if (!element) return;

  const targetValue = parseFloat(toValue) || 0;
  const fromValue = priceAnimationState.has(element) ? priceAnimationState.get(element) : targetValue;
  priceAnimationState.set(element, targetValue);

  if (prefersReducedMotion || fromValue === targetValue) {
    element.textContent = `${prefix}${formatPrice(targetValue)}`;
    return;
  }

  const animationToken = String(++animationTokenCounter);
  element.dataset.animationToken = animationToken;
  const startTime = performance.now();

  function step(now) {
    if (element.dataset.animationToken !== animationToken) return; // von neuerer Animation überholt

    const progress = Math.min((now - startTime) / duration, 1);
    const eased = 1 - Math.pow(1 - progress, 3); // ease-out
    const current = fromValue + (targetValue - fromValue) * eased;
    element.textContent = `${prefix}${formatPrice(current)}`;

    if (progress < 1) {
      requestAnimationFrame(step);
    } else {
      element.textContent = `${prefix}${formatPrice(targetValue)}`;
    }
  }

  requestAnimationFrame(step);
}

async function calculateTotalPrice() {
  let rackPrice = parseFloat(rackNumericPrice) || 0;
  let accessories_total = 0;

  const selects = document.querySelectorAll('.accessory-select');
  const totalElement = document.getElementById('totalPrice');

  function updateTotalPrice() {
    accessories_total = 0;

    selects.forEach(select => {
      let accessories_sku = select.id.trim().replace(/["]/g, '');
      const preis = parseFloat(window.accessoryPrices[accessories_sku]) || 0;
      const quantity = parseInt(select.value) || 0;
      const accessoryTotal = preis * quantity;
      accessories_total += accessoryTotal;

      const totalEl = document.getElementById(`total-${accessories_sku}`);
      if (totalEl) animateValue(totalEl, accessoryTotal, { prefix: rcT('subtotalPrefix', 'Gesamt: ') });
    });

    const totalPrice = rackPrice + accessories_total;
    if (totalElement) animateValue(totalElement, totalPrice, { prefix: rcT('totalPrefix', 'Gesamtpreis: ') });

    return totalPrice;
  }

  selects.forEach(select => {
    select.addEventListener('change', updateTotalPrice);
  });

  return updateTotalPrice();
}

async function updateFinalPrice() {
  const totalPrice = await calculateTotalPrice();
  const priceOutput = document.getElementById('finalPriceOutput');

  if (priceOutput) {
    animateValue(priceOutput, totalPrice, { prefix: rcT('totalPrefix', 'Gesamtpreis: ') });
  } else {
    console.error("Fehler: Element 'finalPriceOutput' nicht gefunden.");
  }
}

async function addToCart() {
  const { line, height, depth, width, door } = getCurrentSelection();
  const articleNumber = buildArticleNumber(line, width, depth, height, door);

  const selects = Array.from(document.querySelectorAll('.accessory-select')).filter(select => parseInt(select.value) > 0);
  const selectedSkus = selects.map(select => select.id.trim());

  const [rackVariant, accessoryResults] = await Promise.all([
    getProductInfo(articleNumber),
    getMultipleProductInfos(selectedSkus)
  ]);

  if (!rackVariant || !rackVariant.variantID) {
    alert(rcT('cartError', 'Der Serverschrank konnte nicht zum Warenkorb hinzugefügt werden.'));
    return;
  }

  const selectedAccessories = selectedSkus
    .map((sku, index) => {
      const variant = accessoryResults[index];
      const quantity = parseInt(selects[index].value);

      if (variant && variant.variantID) {
        return { variantId: variant.variantID, quantity };
      }
      console.error(`Variante für SKU ${sku} nicht gefunden.`);
      return null;
    })
    .filter(Boolean);

  let items = `${rackVariant.variantID.replace('gid://shopify/ProductVariant/', '')}:1`;

  if (selectedAccessories.length > 0) {
    items += ',' + selectedAccessories.map(accessory =>
      `${accessory.variantId.replace('gid://shopify/ProductVariant/', '')}:${accessory.quantity}`
    ).join(',');
  }

  const shopifyUrl = `https://brocon-shop.com/cart/${items}`;
  window.location.href = shopifyUrl;
}

function showInquiryForm(unavailableItems) {
  const modal = document.getElementById('inquiryModal');
  const overlay = document.getElementById('modalOverlay');
  const textarea = document.getElementById('inquiryItems');

  const { line, height, depth, width, door } = getCurrentSelection();
  const articleNumber = buildArticleNumber(line, width, depth, height, door);

  let inquiryText = `${rcT('inquiryRackSku', 'Schrank Artikelnummer:')} ${articleNumber}\n\n${rcT('inquiryAccessories', 'Zubehör:')}\n`;

  const selects = document.querySelectorAll('.accessory-select');
  selects.forEach(select => {
    const sku = select.id.trim();
    const quantity = parseInt(select.value, 10);

    if (quantity > 0) {
      const available = document.getElementById(sku).parentNode.querySelector('.accessory-availability').dataset.available === 'true';
      inquiryText += `${sku} - ${rcT('quantity', 'Menge:')} ${quantity} - ${available ? rcT('available', 'Verfügbar') : rcT('notAvailable', 'Nicht verfügbar')}\n`;
    }
  });

  textarea.value = inquiryText;
  modal.style.display = 'block';
  overlay.style.display = 'block';
}

function closeInquiryModal() {
  document.getElementById('inquiryModal').style.display = 'none';
  document.getElementById('modalOverlay').style.display = 'none';
}

function submitInquiry() {
  const name = document.getElementById('name').value;
  const email = document.getElementById('email').value;
  const items = document.getElementById('inquiryItems').value;

  if (name && email && items) {
    alert(rcT('inquirySent', 'Deine Anfrage wurde gesendet. Wir melden uns in Kürze bei dir.'));
    closeInquiryModal();
  } else {
    alert(rcT('fillAllFields', 'Bitte fülle alle Felder aus.'));
  }
}
